import script from "./DetailHash.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailHash.vue?vue&type=script&setup=true&lang=ts"

import "./DetailHash.vue?vue&type=style&index=0&id=228d71fa&lang=scss"

const __exports__ = script;

export default __exports__